export default {
      id: "therapist-details-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#therapist-details",
      toString: function () {
        return this.url;
      }
    }